import React from 'react';

const LocationDisplay = ({ locationData }) => {
  // Determine what type of location data we have
  const hasAddress = locationData?.address;
  const hasCoordinates = locationData?.latitude && locationData?.longitude;
  const hasImage = locationData?.imageUrl;

  // Generate Google Maps embed URL if coordinates are available
  const googleMapsUrl = hasCoordinates ? 
    `https://maps.google.com/maps?q=${locationData.latitude},${locationData.longitude}&z=15&output=embed` 
    : null;

  if (!locationData) return null;

  return (
    <div className="location-display">
      <div className="">
        {locationData.addressType == "text" && (
          <div className="mb-3">
            <h6 className="card-subtitle">Address: <span className='tw-ml-2 tw-font-normal tw-text-base'>{locationData.address}</span></h6>
          </div>
        )}
        
        {locationData.addressType == "location"  && (
          <div className="mb-3">
            <h6 className="card-subtitle mb-2">GPS Coordinates: 
              <span className='tw-ml-2 tw-font-normal tw-text-base'> Latitude: {locationData.latitude}&nbsp;&nbsp;Longitude: {locationData.longitude}</span></h6>
            
            {/* Display placeholder map during development */}
            {/* <div className="mt-3 border">
              <div className="ratio ratio-16x9" style={{ maxHeight: "250px" }}>
                <iframe
                  src={googleMapsUrl}
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Google Maps"
                ></iframe>
              </div>
            </div> */}
          </div>
        )}
        
        {locationData.addressType == "image" && (
          <div>
            <h6 className="card-subtitle mb-2">Location Map</h6>
            <div className="text-center">
              <img 
                src={locationData.imageUrl} 
                alt="Location Map" 
                className="img-fluid border" 
                style={{ maxHeight: '200px' }}
              />
            </div>
          </div>
        )}

        {!hasAddress && !hasCoordinates && !hasImage && (
          <div className="alert alert-info mb-0">
            No location information available.
          </div>
        )}
      </div>
    </div>
  );
};

export default LocationDisplay;